import { BaIcon } from '@/components/atoms/ba-icon/vue';

export default {
  components: {
    BaIcon,
  },
  props: {
    tagName: {
      type: String,
      default: 'a',
    },
    to: String,
    modActive: Boolean,
  },
  computed: {
    classes() {
      return [
        'ba-tab',
        {
          'ba-tab--active': this.modActive,
        },
      ];
    },
    computedTagName() {
      if (this.modActive) {
        return 'span';
      }
      return this.tagName;
    },
    inputListeners() {
      return Object.assign(
        {},
        this.$listeners,
      );
    },
  },
};
